export default {
    workOrder_changeStatus_title: "Cambiar Estado",
    workOrder_changeStatus_status: "Estado",
    workOrder_changeStatus_note: "Nota",
    workOrder_changeStatus_successMessage: "El estado ha sido cambiado",
    workOrder_changeStatus_change: "Cambiar",
}